import { render } from "./PlayoutTableItem.vue?vue&type=template&id=3810272e"
import script from "./PlayoutTableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutTableItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayout/PlayoutTableItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3810272e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3810272e', __exports__)) {
    api.reload('3810272e', __exports__)
  }
  
  module.hot.accept("./PlayoutTableItem.vue?vue&type=template&id=3810272e", () => {
    api.rerender('3810272e', render)
  })

}


export default __exports__